import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREADCRUMBS
\*------------------------------------ */
/**
 * 1) An ordered list of navigational hierarchy showing the user where they are on the site
 */
.cat-c-breadcrumbs__list {
  display: flex;
  flex-wrap: wrap;
  padding: calc(-1 * var(--cat-space-x-small)) 0 0 calc(-1 * var(--cat-space-x-small));
  margin: 0;
  list-style: none;
  /**
  * 1) Slotted breadcrumbs item component
  */
}
.cat-c-breadcrumbs__list ::slotted(cat-breadcrumbs-item) {
  margin-inline-start: var(--cat-space-x-small);
  margin-block-start: var(--cat-space-x-small);
}
.cat-c-breadcrumbs__list ::slotted(*) {
  display: flex;
  flex-wrap: wrap;
}

.cat-c-breadcrumb__tooltip {
  position: absolute;
  inset-inline-start: 40%;
  inset-block-start: calc(var(--size-base-unit) * -2.5);
}

.cat-breadcrumbitem-ellipsis {
  position: relative;
}

.cat-c-breadcrumbs__item-loader {
  --cat-c-breadcrumb__item-loader-content: none;
}
.cat-c-breadcrumbs__item-loader cat-breadcrumbs-item[isLast] {
  display: flex;
}

.cat-c-breadcrumbs-item-menu-trigger:focus-visible {
  --cat-theme-offset-focus-ring: 0;
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

.cat-c-breadcrumbs:not(.cat-c-breadcrumbs--has-breadcrumbs) [part=breadcrumb] {
  display: none;
}
`;
       